export default function StatsSection() {
  const stats = [
    { value: '20,000', suffix: '+', label: '部漫画总量' },
    { value: '500', suffix: '万', label: '活跃用户' },
    { value: '200', suffix: '+', label: '话日更上架' },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 leading-relaxed">
              海量正版资源
              <br />
              每日实时更新
              <br />
              免费下拉体验
            </h2>
            <div className="flex items-center gap-0 mt-8">
              {stats.map((stat, index) => (
                <div key={index} className="flex items-center">
                  {index > 0 && <div className="w-px h-12 bg-background-300 mx-6"></div>}
                  <div>
                    <div className="text-3xl md:text-4xl font-bold text-accent-500">
                      {stat.value}
                      <span className="text-2xl">{stat.suffix}</span>
                    </div>
                    <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 relative h-48 md:h-64 w-full overflow-hidden rounded-lg bg-gradient-to-br from-accent-100/50 via-background-50 to-secondary-100/50">
            <div className="absolute top-4 right-8 w-24 h-24 rounded-2xl bg-accent-200/40 rotate-12"></div>
            <div className="absolute bottom-8 left-4 w-20 h-20 rounded-full bg-secondary-200/40"></div>
            <div className="absolute top-12 left-12 w-16 h-16 rounded-lg bg-primary-200/40 -rotate-6"></div>
            <div className="absolute bottom-4 right-12 w-28 h-28 rounded-3xl bg-accent-100/30 rotate-45"></div>
            <div className="absolute top-20 right-20 w-12 h-12 rounded-full bg-secondary-300/30"></div>
          </div>
        </div>
      </div>
    </section>
  );
}